import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Q11 = ({ userId, onNext, onPrevious, saveResponse }) => {
    const [selectedOption, setSelectedOption] = useState({ score: null, description: '' });
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    const options = [
        { value: 6, label: t('questions.q11.options.8to10') },
        { value: 4, label: t('questions.q11.options.11to13') },
        { value: 2, label: t('questions.q11.options.15to17') },
        { value: 0, label: t('questions.q11.options.19to21') }
    ];

    useEffect(() => {
        const fetchExistingResponse = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.token) {
                    throw new Error('No token found in localStorage');
                }
                const token = user.token;

                const baseUrl = process.env.REACT_APP_API_URL

                const response = await axios.get(`${baseUrl}/survey/get-response/q11/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.data && response.data.score) {
                    setSelectedOption(response.data);
                }
            } catch (error) {
                console.error('Error fetching existing response:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchExistingResponse();
    }, [userId]);

    useEffect(() => {
        console.log('Selected option updated:', selectedOption);
    }, [selectedOption]);

    const handleOptionChange = (e) => {
        const selectedValue = parseInt(e.target.value);
        const selectedLabel = options.find(option => option.value === selectedValue).label;
        setSelectedOption({ score: selectedValue, description: selectedLabel });
    };

    const handleNext = () => {
        if (selectedOption.score !== null) {
            saveResponse('q11', selectedOption);
            console.log('Saving response for q11:', selectedOption); // Add this line for debugging
            onNext();
        }
    };

    if (loading) {
        return <p>{t('questions.q11.loading')}</p>;
    }

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3>{t('questions.q11.title')}</h3>
            <form>
                {options.map(option => (
                    <div key={option.value}>
                        <input
                            type="radio"
                            id={`option${option.value}`}
                            name="q11"
                            value={option.value}
                            checked={selectedOption.score === option.value}
                            onChange={handleOptionChange}
                        />
                        <label htmlFor={`option${option.value}`}>{option.label} ({option.value})</label>
                    </div>
                ))}
            </form>
            <button onClick={onPrevious} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}>{t('questions.q11.previous')}</button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button onClick={handleNext} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }} disabled={selectedOption.score === null}>{t('questions.q11.next')}</button>
        </div>
    );
};

export default Q11;
